module.exports = __webpack_public_path__ + "media/header-xl.2a517de8.webm";